/* dsp-same-car.js — fetches sections/dsp-same-car.liquid in search context (Section Rendering API),
   drops the current product, trims to the limit and injects the ruled grid. Hides itself otherwise. */
(function () {
  'use strict';
  if (customElements.get('dsp-same-car')) return;

  function productHandle(href) {
    var i = href.indexOf('/products/');
    if (i === -1) return '';
    return href.slice(i + 10).split(/[?#\/]/)[0];
  }

  class DspSameCar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = '1';
      var start = this.load.bind(this);
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1500 });
      else window.setTimeout(start, 0);
    }

    load() {
      var url = this.dataset.url;
      var handle = this.dataset.handle || '';
      var limit = parseInt(this.dataset.limit, 10) || 8;
      var target = this.querySelector('[data-dsp-same-car-target]');
      if (!url || !target) return this.dismiss();

      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('.dsp-same-car__grid');
          if (!grid) return this.dismiss();

          Array.prototype.forEach.call(grid.querySelectorAll('.dsp-grid__cell'), function (cell) {
            var link = cell.querySelector('a[href*="/products/"]');
            if (link && handle && productHandle(link.getAttribute('href')) === handle) cell.remove();
          });

          var cells = grid.querySelectorAll('.dsp-grid__cell');
          if (cells.length < 2) return this.dismiss();
          Array.prototype.forEach.call(cells, function (cell, index) {
            if (index >= limit) cell.remove();
          });

          target.innerHTML = '';
          target.appendChild(grid);
          this.removeAttribute('hidden');
        }.bind(this))
        .catch(function () {
          this.dismiss();
        }.bind(this));
    }

    dismiss() {
      var wrapper = this.closest('.shopify-section') || this;
      wrapper.setAttribute('hidden', '');
    }
  }

  customElements.define('dsp-same-car', DspSameCar);
})();
